import type { IView } from '@barba/core';
import { IdleQueue } from 'idlize/IdleQueue.mjs';
import pageAnimations from '../animations/pages/order/init-page-animations';
import orderFunctionalHandlers from '../inits/pages/order/order-functional-handlers';
import addressInputHandling from '../inits/components/common/address-input-handling';

const beforeEnterQueue = new IdleQueue();

export default {
    namespace: 'order-page',

    beforeEnter() {
        beforeEnterQueue.pushTask(() => {
            pageAnimations.init();
            orderFunctionalHandlers.init();
            addressInputHandling.init('.js-address-value-input-group');
            addressInputHandling.init('.js-city-value-input-group');
        });
    },

    beforeLeave() {
        orderFunctionalHandlers.destroy();
        addressInputHandling.destroy();
    },
} as IView;
